var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#f5f5f5"}},[_c('examHeader'),_c('el-main',{staticClass:"exam_container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }